<template>
  <section class="couponGuideCardWrap">
    <a 
      :href="cardsData.href"
      target="_blank"
      v-if= "ishref == true"
      class="couponGuideCardBlock" 
      @click="omgup(cardsData.title)"
    >
      <div class="iconBlock">
        <img :src=cardsData.icon alt="">
      </div>
      <div class="contentBlock">
        <div class="title">{{cardsData.title}}</div>
        <div class="content">{{cardsData.content}}</div>
      </div>
    </a>
    <div 
      v-else
      :class="['couponGuideCardBlock',cardsData.key == curCardKey  ? 'cur' : '']" 
      @click="handleCardClick(cardsData.key,cardsData.title)"
    >
      <div class="iconBlock">
        <img :src=cardsData.icon alt="">
      </div>
      <div class="contentBlock">
        <div class="title">{{cardsData.title}}</div>
        <div class="content">{{cardsData.content}}</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'CouponGuideCard',
  componentName: 'CouponGuideCard',
  props:['cardsData','curCardKey',"ishref"],
  methods:{
    handleCardClick:function(key,title){
      this.$emit('listenCardClick', key,title)
    },
    omgup:function(content){
      this.omgTrack('es_chuxingquan_buy_formwork_ck', '出行券_购券管理_模版_点击',{content})
    }
  }
}
</script>

<style lang="stylus">
.couponGuideCardWrap{
  .couponGuideCardBlock{
    width: 305px;
    height: 48px;
    border: 2px solid #EEEEEE;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-decoration: none
    .iconBlock{
      width: 32px;
      height: 32px;
      img{
        border-radius: 50%
        width: 32px;
        height: 32px;
      }
    }
    .contentBlock{
      margin: 3px 0 0 8px;
      .title{
        font-size: 18px;
        color: #333333;
        font-weight: 500;
        line-height: 25px
      }
      .content{
        font-size: 13px;
        color: #999999;
        font-weight: 400;
        line-height: 18px
      }
    }
  }
  .cur{
    border: 2px solid #3468FF;
  }
}
</style>
